import { SafetyInspectionFacility, SafetyInspectionLocation } from "../DTOs";
import { assertNever } from "../util";

export type LocationInspectionSummary = 
{
    state:
        'no-facilities' |
        'no-inspections' |
        'not-started' |
        'in-progress' |
        'completed' |
        'completed-all-passed',
    allPassed:number,
    completed:number,
    inProgress:number,
    notStarted:number,
    noInspections: number,
    total:number
}


export type FacilityInspectionSummary = 
{
    state: 
        'no-inspections' | 
        'not-started' | 
        'in-progress' | 
        'completed' |
        'completed-all-passed',
    passed: number,
    failed: number,
    notStarted: number,
    total: number,
}

export const safetyInspectionSummaryHelper = {
    getLocationInspectionSummary,
    getFacilityInspectionSummary
}

function getLocationInspectionSummary (location: SafetyInspectionLocation): LocationInspectionSummary
{
    const locationSummary:LocationInspectionSummary = {
        state: 'no-facilities',
        allPassed: 0,
        completed: 0,
        inProgress: 0,
        notStarted: 0,
        noInspections:0,
        total: 0
    }

    for(const f of location.facilities){
        const facilitySummary = getFacilityInspectionSummary(f);
        switch(facilitySummary.state){
            case 'completed-all-passed': locationSummary.allPassed++; break;
            case 'completed': locationSummary.completed++; break;
            case 'in-progress': locationSummary.inProgress++; break;
            case 'not-started': locationSummary.notStarted++; break;
            case 'no-inspections': locationSummary.noInspections++; break;
            default: assertNever(facilitySummary.state);
        }
        locationSummary.total ++;
    }

    // Special cases
    if(location.facilities.length === 0)
        locationSummary.state = 'no-facilities';
    else if(locationSummary.total === 0 || locationSummary.noInspections === locationSummary.total)
        locationSummary.state = 'no-inspections';
    else{
        if(locationSummary.allPassed === locationSummary.total)
            locationSummary.state = 'completed-all-passed';
        else if(locationSummary.notStarted === 0)
            locationSummary.state = 'completed';
        else if(locationSummary.notStarted === locationSummary.total)
            locationSummary.state = 'not-started';
        else
            locationSummary.state = 'in-progress';  
    }

    return locationSummary;
}

function getFacilityInspectionSummary (facility: SafetyInspectionFacility): FacilityInspectionSummary
{
    const inspections = facility.inspectionPoints;

    const passedInspections = inspections.filter(i => i.inspectionResult.status === 'passed');
    const failedInspections = inspections.filter(i => i.inspectionResult.status === 'failed');
    const pendingInspections = inspections.filter(i => i.inspectionResult.status === 'pending');

    const summary:FacilityInspectionSummary = {
        state:'in-progress',
        passed: passedInspections.length,
        failed: failedInspections.length,
        notStarted: pendingInspections.length,
        total: inspections.length
    }

    if (inspections.length === 0)
    {
        summary.state = 'no-inspections';
    }
    else if (pendingInspections.length === inspections.length)
    {
        summary.state = 'not-started';
    }
    else if (passedInspections.length === inspections.length)
    {
        summary.state = 'completed-all-passed';
    }
    else if (pendingInspections.length === 0)
    {
        summary.state = 'completed';
    }
    else
    {
        summary.state = 'in-progress';
    }

    return summary;
}